import { useEffect, useState } from 'react';
import { TabList, TabListProps } from '@mui/lab';
import { useUi } from 'hooks/useUi';
import { verticalHeightBreakpoint } from 'lib/constants';

const verticallyCompressedTabsStyle = {
    minHeight: '32px',
};

export const TuTabList = (props: TabListProps) => {
    const { ui } = useUi();
    const [shouldMinimize, setShouldMinimize] = useState(false);
    useEffect(() => {
        if (ui.height < verticalHeightBreakpoint) setShouldMinimize(true);
        else setShouldMinimize(false);
    }, [ui.height]);

    return shouldMinimize ? (
        <TabList
            data-testid="TuTabList"
            {...props}
            sx={{ ...props.sx, ...verticallyCompressedTabsStyle }}
        >
            {props.children}
        </TabList>
    ) : (
        <TabList data-testid="TuTabList" {...props}>
            {props.children}
        </TabList>
    );
};
